import { hostLeaveResponseSchema, livekitConnectionSchema } from '@apovisio/contracts';
import type { HostLeaveResponse, LivekitConnection } from '@apovisio/contracts';
import { apiFetch } from '../../lib/api';

export function fetchGuestToken(): Promise<LivekitConnection> {
  return apiFetch('/api/guest/token', { method: 'POST', schema: livekitConnectionSchema });
}

export function leaveAsGuest(): Promise<undefined> {
  return apiFetch<undefined>('/api/guest/leave', { method: 'POST' });
}

export function joinAsHost(meetingId: string): Promise<LivekitConnection> {
  return apiFetch(`/api/meetings/${meetingId}/token`, {
    method: 'POST',
    schema: livekitConnectionSchema,
  });
}

export function leaveAsHost(meetingId: string, endForAll: boolean): Promise<HostLeaveResponse> {
  return apiFetch(`/api/meetings/${meetingId}/leave`, {
    method: 'POST',
    body: { endForAll },
    schema: hostLeaveResponseSchema,
  });
}
